import React from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { ReactNotifications } from 'react-notifications-component';

import LoginPage from './pages/LoginPage';
import BillingPage from './pages/BillingPage';
import LogoutPage from './pages/LogoutPage';
import RegistrationPage from './pages/RegistrationPage';
import DeleteMyAccount from './pages/DeleteMyAccount';
import CompanyPage from './pages/CompanyPage';
import CompanyUserPage from './pages/CompanyUserPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import ChangePasswordPage from './pages/ChangePasswordPage';

import 'react-notifications-component/dist/theme.css'

class App extends React.Component {

  render() {
    const router = createBrowserRouter(
      [
        { path: '/billing', element: <BillingPage /> },
        { path: '/logout', element: <LogoutPage /> },
        { path: '/registration', element: <RegistrationPage /> },
        { path: '/delete-my-account', element: <DeleteMyAccount /> },
        { path: '/reset-password', element: <ResetPasswordPage /> },
        { path: '/change-password/:token', element: <ChangePasswordPage /> },
        { path: '/oI3Ee9qQvmorXOVu', element: <CompanyPage /> },
        { path: '/oI3Ee9qQvmorXOVu/user/:id', element: <CompanyUserPage /> },
        { path: '/', element: <LoginPage /> }
      ]
    );
    
    return (
      <div className="app-container"> <ReactNotifications /> <RouterProvider router={router} /> </div>
    );
  }
}
export default App;